exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".t-promocode[data-v-4f882c5d]{position:relative;margin-bottom:24px;z-index:2;height:48px}.t-promocode__text[data-v-4f882c5d]{font-size:18px;line-height:20px;font-weight:500;color:#59d;cursor:pointer}.t-promocode__text.marginLeft[data-v-4f882c5d]{margin-left:24px}.t-promocode__text.dashed[data-v-4f882c5d]{border-bottom:1px dashed #59d}.t-promocode__input-wrapper[data-v-4f882c5d]{display:flex;align-items:center}.t-promocode__input-wrapper[data-v-4f882c5d],.t-promocode__text-wrapper[data-v-4f882c5d]{position:absolute;top:0;left:0;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f882c5d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/templates/components/ui/promocode.vue
// module id = 451
// module chunks = 0